import React from "react";
import toast from "react-hot-toast";
import { GiPassport } from "react-icons/gi";
import { IoStarHalfOutline } from "react-icons/io5";
import { MdAirlineSeatReclineNormal } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import MyToaster from "../../../../generic components/toaster/MyToaster";
import axios from "../../../../requests/axios";
import routes from "../../../../requests/routes";
import StatCard from "../../dashboard/stat card/StatCard";
import classes from "./programMain.module.css";
import { message, Space, Switch } from "antd";

const ProgramMain = (props) => {
  const { setProgram } = props;
  const navigate = useNavigate();
  const id = props?.program?._id;

  const handleDelete = () => {
    async function getProgram() {
      try {
        await axios.delete(routes.getPrograms + `/${id}`);
      } catch (err) {
        return Promise.reject(err);
      }
    }
    toast.promise(getProgram(), {
      loading: "Deleting...",
      success: "Program deleted",
      error: "Error deleting program",
    });
  };

  const togglePublish = async (record, checked, attr) => {
    try {
      await axios
        .patch(`${routes.createProgram}/${record._id}`, {
          [attr]: checked,
        })
        .then((res) => {
          setProgram(res.data.program);
          message.success(`${attr} updated!`);
        });
    } catch (e) {
      message.error(`Failed to update ${attr}`);
    }
  };

  return (
    <div>
      <h1 className="adminTitle">Main</h1>
      <div className={classes.stats}>
        <StatCard
          title="Bookings"
          number={10}
          icon=<GiPassport className={classes.icon} />
        />
        <StatCard
          title="Available"
          number={props?.program?.spotsAvailable}
          icon=<MdAirlineSeatReclineNormal className={classes.icon} />
        />
        <StatCard
          title="Rating"
          number={Number(props?.program?.rating).toFixed(2)}
          icon=<IoStarHalfOutline className={classes.icon} />
        />
      </div>
      <div className={classes.controlUnit}>
        <button
          onClick={() => {
            navigate(`/programs/${id}`);
          }}
        >
          View
        </button>
        <button onClick={handleDelete}> Delete </button>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "1rem",
          fontSize: "1.5rem",
          marginTop: "2rem",
        }}
      >
        Is Hosting Organization?
        <Switch
          checked={!!props?.program.isHosting}
          onChange={(c) => togglePublish(props?.program, c, "isHosting")}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "1rem",
          marginTop: "2rem",
          fontSize: "1.5rem",
        }}
      >
        Is Sending Organization?
        <Switch
          checked={!!props?.program.isSending}
          onChange={(c) => togglePublish(props?.program, c, "isSending")}
        />
      </div>
      {/* <div className={classes.requests}>
        <h1>Requests</h1>
        <ProgramsList />
      </div> */}
    </div>
  );
};

export default ProgramMain;
